import { SET_DISCOUNTS, 
    SET_CATEGORIES, 
    SET_CREATE_DISCOUNT_STATUS, 
    SET_CART_ITEMS,
    SET_WISH_LIST, 
    SET_DISCOUNT_PACKAGES,
    SET_DISCOUNT_MEDIA,
    SET_DISCOUNT_REVIEWS,
    SET_SEARCH_RESULT,
    USER_DISCOUNT_LIKE,
    USER_DISCOUNT_LIKES,
    UPDATE_DISCOUNT_LIKES,
    SET_DISCOUNT_LIKED,
    ADD_USER_DISCOUNT_LIKE,
    UPDATE_ORGANIZER_FOLLOWERS,
    REMOVE_USER_DISCOUNT_LIKE
 } from "../actions/actionType";

export const initState = {
    discounts: sessionStorage.getItem('discounts') ?
    JSON.parse(sessionStorage.getItem('discounts')) : [], 
    items: sessionStorage.getItem('cartItems') ?
    JSON.parse(sessionStorage.getItem('cartItems')) : [],
    totalAmount: sessionStorage.getItem('totalAmount') ?
    +JSON.parse(sessionStorage.getItem('totalAmount')) : 0,
    categories: sessionStorage.getItem('categories') ?
    JSON.parse(sessionStorage.getItem('categories')) : null,
    createDiscountStatus: null,
    wishlist: sessionStorage.getItem('wishlist') ?
    JSON.parse(sessionStorage.getItem('wishlist')) : [],    
    discount_packages: sessionStorage.getItem('discount_packages') ?
    JSON.parse(sessionStorage.getItem('discount_packages')) : null,
    discount_media: sessionStorage.getItem('discount_media') ?
    JSON.parse(sessionStorage.getItem('discount_media')) : [],
    reviews: sessionStorage.getItem('reviews') ?
    JSON.parse(sessionStorage.getItem('reviews')) : null, 
    search_result: sessionStorage.getItem('search_result') ? 
    JSON.parse(sessionStorage.getItem('search_result')) : [],  
    user_discount_like: sessionStorage.getItem('user_discount_like') ? 
    JSON.parse(sessionStorage.getItem('user_discount_like')) : null, 
    userDiscountLikes: sessionStorage.getItem('userDiscountLikes') ? 
    JSON.parse(sessionStorage.getItem('userDiscountLikes')) : {}
}

const discountReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_DISCOUNTS:
            sessionStorage.setItem('discounts', JSON.stringify(action.discounts));
            return {
                ...state,
                discounts: action.discounts
            };

        case SET_DISCOUNT_PACKAGES:
            sessionStorage.setItem('discount_packages', JSON.stringify(action.discount_packages));
            return {
                ...state,
                discount_packages: action.discount_packages
            };

        case SET_DISCOUNT_REVIEWS:
            sessionStorage.setItem('reviews', JSON.stringify(action.reviews));
            return {
                ...state,
                reviews: action.reviews
            };

        case SET_DISCOUNT_MEDIA:
            sessionStorage.setItem('discount_media', JSON.stringify(action.discount_media));
            return {
                ...state,
                discount_media: action.discount_media
            };

        case SET_CATEGORIES:
            sessionStorage.setItem('categories', JSON.stringify(action.categories));
            return {
                ...state,
                categories: action.categories,
            };

        case SET_CREATE_DISCOUNT_STATUS:
            return {
                ...state,
                createDiscountStatus: action.createDiscountStatus,
            };
            
        case SET_CART_ITEMS:
            sessionStorage.setItem('cartItems', JSON.stringify(action.cartItems));
            // sessionStorage.setItem('totalAmount', JSON.stringify(updatedTotalAmount));
            return {
                ...state,
                items: action.cartItems,
                totalAmount: action.totalAmount
            };

        case SET_WISH_LIST:
            sessionStorage.setItem('wishlist', JSON.stringify(action.wishlist));
            return {
                ...state,
                wishlist: action.wishlist
            };

        case USER_DISCOUNT_LIKE:
            sessionStorage.setItem('user_discount_like', JSON.stringify(action.user_discount_like));
            return {
                ...state,
                user_discount_like: action.user_discount_like
                };

        case USER_DISCOUNT_LIKES:
            sessionStorage.setItem('userDiscountLikes', JSON.stringify(action.userDiscountLikes));
            return {
                ...state,
                userDiscountLikes: action.userDiscountLikes,
            };

        case SET_SEARCH_RESULT:
            sessionStorage.setItem('search_result', JSON.stringify(action.search_result));
            return {
                ...state,
                search_result: action.search_result
            };

        case UPDATE_DISCOUNT_LIKES:
            return {
                ...state,
                discounts: {
                ...state.discounts,
                results: state.discounts.results.map((d) =>
                    d.id === action.payload.discountId
                    ? { ...d, likes: action.payload.likes }
                    : d
                ),
                },
            };

        case ADD_USER_DISCOUNT_LIKE: {
            const updated = {
                ...state.userDiscountLikes,
                [action.discountId]: action.likeData,
            };
            sessionStorage.setItem('userDiscountLikes', JSON.stringify(updated));
            return { ...state, userDiscountLikes: updated };
        }
     
        case UPDATE_ORGANIZER_FOLLOWERS:
            return {
                ...state,
                discounts: {
                    ...state.discounts,
                    results: state.discounts.results.map(d =>
                        d.organizer.id === action.payload.organizerId
                            ? {
                                ...d,
                                organizer: {
                                    ...d.organizer,
                                    followers: action.payload.followers
                                }
                            }
                            : d
                    )
                }
            };

        case REMOVE_USER_DISCOUNT_LIKE: {
            const newLikes = { ...state.userDiscountLikes };
            delete newLikes[action.discountId];
            sessionStorage.setItem('userDiscountLikes', JSON.stringify(newLikes));
            return { ...state, userDiscountLikes: newLikes };
        }

        default:
            return state;
    }
}


export default discountReducer;